import { queryOptions, useQuery } from "@tanstack/react-query";

export type Policy = {
  /** Human readable name */
  name: string;
  /** Human readable description */
  description: string;
  entities: Array<string>;
  entities_aggregated: Array<string>;
};

type Policies = Record<string, Policy>;

const policiesPlaceholder: Policies = {
  HIPAA: {
    name: "HIPAA",
    description:
      "HIPAA compliance redaction policy using backend recognized entities.",
    entities: [
      "FIRSTNAME",
      "MIDDLENAME",
      "LASTNAME",
      "STREET",
      "Address",
      "BUILDINGNUMBER",
      "SECONDARYADDRESS",
      "CITY",
      "COUNTY",
      "ZIPCODE",
      "TIMEDATE",
      "PHONENUMBER",
      "EMAIL",
      "SSN",
      "ACCOUNTNUMBER",
      "IDCARD",
      "VEHICLEIDENTIFIERS",
      "DEVICEIDENTIFIERS",
      "URL",
      "MASKEDSEQUENCE",
    ],
    entities_aggregated: [
      "Social Security Number",
      "Vehicle Identifier",
      "URL",
      "Zipcode",
      "Phone Number",
      "Date/Time",
      "Device Identifier",
      "Location",
      "Masked Number",
      "Email",
      "SSN",
      "Person",
      "Account Number",
      "Address",
    ],
  },
};

async function getPolicies() {
  return await Promise.resolve(policiesPlaceholder);
  // return api.governance.get<Policies>("gcp/pii/full_policy_list").json();
}

export const governancePoliciesQueryOptions = queryOptions({
  queryKey: ["governance", "policies"],
  queryFn: getPolicies,
});

export function useGovernancePolicies() {
  return useQuery(governancePoliciesQueryOptions);
}
